import is from '@/utils/is';
import { useState } from 'react';
import Button from '../Button';
import Div from '../Div';
import Input from '../Input';
import Paragraph from '../Paragraph';
import Coupon from './Coupon';
import Map from '@/components/Map';
import CrossIcon from '@/components/Icons/Cross';
import PercentageIcon from '@/components/Icons/Percentage';

function CouponContent(
  coupons: any,
  onClose: any,
  onApply: any,
  cartId?: string,
  errorMessage?: string,
) {
  const render = (item: any, index: number) => {
    return <Coupon key={index} value={item} onApply={onApply} cartId={cartId} />;
  };

  const [couponCode, setCouponCode] = useState<string>('');

  const onCouponCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCouponCode((event.target.value as string).trim());
  };

  const validateCoupon = () => {
    onApply(couponCode.toUpperCase());
  };

  return (
    <>
      <Div className="flex flex-col gap-s6 left-0 right-0 bg-cs-primary p-s6">
        <Div className="flex flex-row gap-s3">
          <Paragraph className="flex-1 text-h-3">Apply Coupon</Paragraph>
          <Button theme="none" onClick={onClose}>
            <CrossIcon />
          </Button>
        </Div>

        <Div className="flex flex-col gap-s3">
          <Div className={'border border-gray-300 rounded-cxs flex items-center grow pr-s4'}>
            <Input
              className="border border-none !outline-none uppercase"
              placeholder="Enter Coupon Code"
              onChange={onCouponCodeChange}
              name={''}
            />
            <Button
              theme="link"
              className="text-h-4"
              onClick={validateCoupon}
              disabled={couponCode.length < 3}
            >
              Apply
            </Button>
          </Div>

          <Div forceRender={is.not.null(errorMessage)} className="text-body-base  text-red-500">
            {errorMessage}
          </Div>
        </Div>

        {/* <InputBoxWithAction
            dataTestId={`coupon-code`}
            classNames="grow"
            inputProps={{
              id: 'couponCode',
              value: couponCode,
              placeholder: 'Enter Coupon Code',
              onChange: onCouponCodeChange,
              disabled: false,
            
            }}
            buttonWithLoaderProps={{
              variant: 'link',
              children: 'Apply',
              onClick: validateCoupon,
              isLoading: false,
            }}
          /> */}
      </Div>

      {is.empty.array(coupons) ? (
        <Div className="px-s6 pb-s6 flex gap-s4 items-center">
          <PercentageIcon fillColor={'#7E7E7E'} />
          <Paragraph className="text-body-lg">No coupons available</Paragraph>
        </Div>
      ) : (
        <Div className="bg-cs-secondary overflow-y-auto hide-scrollbar max-h-[calc(100vh-16rem)] md:max-h-[calc(100vh-9.4rem)]">
          <Map className="flex flex-col gap-s5 p-s6" list={coupons} render={render} />
        </Div>
      )}
    </>
  );
}

export default CouponContent;
